import { render, staticRenderFns } from "./customQueryField.vue?vue&type=template&id=2c48ea3a&"
import script from "./customQueryField.vue?vue&type=script&lang=js&"
export * from "./customQueryField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/query/customQueryField.vue"
export default component.exports